import React, { ReactNode, useState } from "react";
import { JsxChild } from "typescript";
import AppIcons from "../../utils/AppIcons";

interface ISearchFilterCardProps {
  title: string;
  children: ReactNode;
}

function SearchFilterCard({ title, children }: ISearchFilterCardProps) {
  const [open, setOpen] = useState(true);

  const contentCSS = open
    ? "filter-card-content"
    : "filter-card-content filter-card-content-collapsed";

  return (
    <div className="filter-card">
      <div className="filter-card-header" onClick={() => setOpen(!open)}>
        <h3>{title}</h3>
        {open && AppIcons.CHEVRON_UP}
        {!open && AppIcons.CHEVRON_DOWN}
      </div>
      <div className={contentCSS}>{children}</div>
    </div>
  );
}

export default SearchFilterCard;
